exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n    background-color: #fafafa;\n    color: #4d81ca;\n}\n\n@media screen and (min-width: 1201px) {\n    body {\n        font-size: 24px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    body {\n        font-size: 20px;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    body {\n        font-size: 18px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    body {\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    body {\n        font-size: 14px;\n    }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/apache/localhost/www/Angular/task2/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/apache/localhost/www/Angular/task2/~/postcss-loader?{"ident":"postcss"}!C:/apache/localhost/www/Angular/task2/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2